import { css } from '@/styled-system/css';

export const headerNavMobileContainerCX = css({
  fontSize: 'sm',
  lineHeight: 'sm',
  WebkitTouchCallout: 'none',
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  display: { base: 'flex', md: 'none' },
  alignItems: 'center',
  flexDir: 'row',
  height: 'hdpNavBarHeightMd',
  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 4px 0px, rgb(242, 242, 242) 0px 0px 0px 0px inset',
});

export const headerNavMobileLogoCX = css({
  marginLeft: '12px',
});

export const autocompleteContainerCX = css({
  flex: '1',
  marginLeft: '9px',
});
